module.exports = __webpack_public_path__ + "static/img/1.5579a7c7.png";